"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styling_1 = require("../../framework/stencil/styling");
const Text_1 = __importDefault(require("../../framework/stencil/Text"));
const styles_1 = __importDefault(require("./styles"));
exports.default = (props) => {
    const { isError, timeText, locationText, staticText, } = props;
    const styles = (0, styling_1.useStyling)(styles_1.default);
    if (!isError) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Text_1.default, { style: styles.dayOneTileTextContent, testID: "tile-time-text" }, timeText),
            react_1.default.createElement(Text_1.default, { style: styles.dayOneTileTextContent, testID: "tile-location-text" }, locationText)));
    }
    return (react_1.default.createElement(Text_1.default, { style: styles.dayOneTileTextContent, testID: "tile-static-text" }, staticText));
};
//# sourceMappingURL=DayOneInfoContent.js.map